import React, { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import gsap from 'gsap/all'

import media from 'styles/media'

import Input from 'components/forms/Input'
import SubmitButton from 'components/buttons/Submit'

const EmailCapture: React.FC = () => {

  const [email, setEmail] = useState<string>('')
  const [error, setError] = useState<string>("")
  const [success, setSuccess] = useState<string>("")
  const [loading, setLoading] = useState<boolean>(false)
  const [circleRef, setCircleRef] = useState<SVGElement | null>(null)
  const animation = useRef<gsap.core.Tween | null>(null)

  const submit = () => {
    setLoading(true)
    const URL = "https://us-central1-metaview-dev-54898.cloudfunctions.net/v2-leads-create"

    fetch(URL, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        audience: "EMAIL_SUBSCRIBERS"
      })
    })
    .then(resp => {
      setLoading(false)
      if (resp.status === 200) {
        setError("")
        setSuccess("Success! Stay tuned for updates")
      } else {
        setError( "Email invalid. Please try again")
        setSuccess("")
      }
    })
  }

  useEffect(() => {
    if (circleRef) {
      const anim = gsap.to(circleRef, {
        paused: true,
        duration: 1,
        repeat: -1,
        rotate: 360,
        ease: "none"
      })

      animation.current = anim
    }
  }, [circleRef])

  useEffect(() => {      
    if (loading) {
      animation.current?.play()
    } else {
      animation.current?.pause()
    }
  }, [loading])

  return (
    <Wrapper>
      <Input
        value={email}
        setValue={setEmail}
        type="email"
        placeholder={"Enter your email address"}
        error={error}
        success={success}
      />
      <SubmitButton onClick={submit}>Submit</SubmitButton>
      <SVG ref={ref => setCircleRef(ref)} fill="none">
        {loading && <Circle cx="50%" cy="50%" r="45%" strokeDasharray="35, 15"/>}
      </SVG>
    </Wrapper>
  )
}

export default EmailCapture

const Wrapper = styled.div`
  position: relative;
`

const SVG = styled.svg`
  position: absolute;
  z-index: 3;
  transform-origin: 50% 50%;

  width: 1.5vw;
  height: 1.5vw;
  top: 1.2vw;
  right: 1.2vw;

  ${media.tablet} {
    width: 1.95vw;
    height: 1.95vw;
    top: 1.76vw;
    right: 1.76vw;
  }

  ${media.mobile} {
    width: 5.33vw;
    height: 5.33vw;
    top: 4.8vw;
    right: 4.8vw;
  }
`

const Circle = styled.circle`
  stroke: url(#horizontalGradient);
  stroke-width: 2px;
  transform-origin: 50% 50%;
`